import React, {Children, cloneElement} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {createStyles, withStyles} from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import withWidth from '@material-ui/core/withWidth';
import compose from 'recompose/compose';
import {toggleSidebar as toggleSidebarAction} from 'ra-core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {Headroom, LoadingIndicator} from 'react-admin';
import Button from '@material-ui/core/Button';
import {getKeycloakSsoConfig} from '../api/keycloak-sso-config';

const styles = theme =>
    createStyles({
        toolbar: {
            paddingRight: 24,
        },
        menuButton: {
            marginLeft: '0.5em',
            marginRight: '0.5em',
        },
        menuButtonIconClosed: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(0deg)',
        },
        menuButtonIconOpen: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(180deg)',
        },
        title: {
            flex: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        username: {
            marginRight: 16,
            color: '#fff',
            fontWeight: 500,
        },
        backButton: {
            color: '#fff',
            textTransform: 'none',
            marginLeft: 8,
        },
    });

const handleBackToMain = async () => {
    try {
        const {baseUIUri} = await getKeycloakSsoConfig();
        window.location.href = baseUIUri;
    } catch (error) {
        console.error('Unable to load the main UI URL', error);
    }
};

const AppBar = ({
                    children,
                    classes,
                    className,
                    logo,
                    logout,
                    open,
                    title,
                    toggleSidebar,
                    notificationMenu,
                    userMenu,
                    width,
                    ...rest
                }) => {
    const username =
        localStorage.getItem('username') || '';

    const onClick = () => {
        toggleSidebar();
        window.menuSideBarOpen = !open;
    };

    return (
        <Headroom>
            <MuiAppBar
                className={className}
                color="secondary"
                position="static"
                {...rest}
            >
                <Toolbar
                    disableGutters
                    variant={width === 'xs' ? 'regular' : 'dense'}
                    className={classes.toolbar}
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={onClick}
                        className={classNames(classes.menuButton)}
                    >
                        <MenuIcon
                            classes={{
                                root: open
                                    ? classes.menuButtonIconOpen
                                    : classes.menuButtonIconClosed,
                            }}
                        />
                    </IconButton>

                    {Children.count(children) === 0 ? (
                        <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.title}
                            id="react-admin-title"
                        />
                    ) : (
                        children
                    )}

                    {notificationMenu && cloneElement(notificationMenu)}

                    <LoadingIndicator/>

                    {username && (
                        <Typography
                            variant="body1"
                            color="inherit"
                            className={classes.username}
                        >
                            {username}
                        </Typography>
                    )}

                    <Button
                        className={classes.backButton}
                        onClick={handleBackToMain}
                    >
                        <ArrowBackIcon style={{marginRight: 6, fontSize: 20}}/>
                        Quay lại trang chính
                    </Button>
                </Toolbar>
            </MuiAppBar>
        </Headroom>
    );
};

AppBar.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    className: PropTypes.string,
    logout: PropTypes.element,
    open: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    userMenu: PropTypes.node,
    width: PropTypes.string,
};

const enhance = compose(
    connect(
        state => ({
            locale: state.i18n.locale,
        }),
        {
            toggleSidebar: toggleSidebarAction,
        }
    ),
    withStyles(styles),
    withWidth()
);

export default enhance(AppBar);
